import { render, staticRenderFns } from "./RegisterCloud.vue?vue&type=template&id=8dafd70a"
import script from "./RegisterCloud.vue?vue&type=script&lang=js"
export * from "./RegisterCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports